import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';

import RiskAssessmentKeyReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/risk-assessment-key.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(RiskAssessmentKeyReducer, defaultState, asyncActions);
};

type IRiskAssessmentKeyContext = ReturnType<typeof useReducer>;

const RiskAssessmentKeyContext = createContext<
  Partial<IRiskAssessmentKeyContext>
>({
  state: defaultState,
}) as React.Context<IRiskAssessmentKeyContext>;

const RiskAssessmentKeyProvider: React.FC = ({ children }) => {
  const reducer = useReducer();
  return (
    <RiskAssessmentKeyContext.Provider value={{ ...reducer }}>
      {children}
    </RiskAssessmentKeyContext.Provider>
  );
};

export const useRiskAssessmentKeyContext = () =>
  useContext(RiskAssessmentKeyContext);

export type IUseRiskAssessmentKeyContext = ReturnType<
  typeof useRiskAssessmentKeyContext
>;

export { RiskAssessmentKeyContext, RiskAssessmentKeyProvider };
